import React, { useEffect, useState } from "react";
//import * as Yup from "yup";
import { useNavigate } from "react-router-dom";

export default function TaxForm({ onSubmit, loading = false, isEdit = false, initialData = {} }) {
  const navigate = useNavigate();

  const initialState = {
    taxName: "",
    cgstPercentage: "",
    sgstPercentage: "",
    igstPercentage: "",
  };

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    if (initialData && Object.keys(initialData).length > 0) {
      setFormData({
        taxName: initialData.taxName || "",
        cgstPercentage: initialData.cgstPercentage || "",
        sgstPercentage: initialData.sgstPercentage || "",
        igstPercentage: initialData.igstPercentage || "",
      });
    }
  }, [initialData]);

  //const validationSchema = Yup.object({
  // taxName: Yup.string()
  // .trim()
  //.required("Tax Name is required"),

  //cgstPercentage: Yup.number()
  //.typeError("CGST is required")
  //.min(0, "CGST cannot be less than 0")
  //.max(100, "CGST cannot exceed 100")
  //.required("CGST is required"),

  // sgstPercentage: Yup.number()
  // .typeError("SGST is required")
  //.min(0, "SGST cannot be less than 0")
  //.max(100, "SGST cannot exceed 100")
  //.required("SGST is required"),

  // igstPercentage: Yup.number()
  //   .typeError("IGST is required")
  // .min(0, "IGST cannot be less than 0")
  // .max(100, "IGST cannot exceed 100")
  // .required("IGST is required"),
  // });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setErrors({});

      const payload = {
        taxName: formData.taxName,
        cgstPercentage: Number(formData.cgstPercentage),
        sgstPercentage: Number(formData.sgstPercentage),
        igstPercentage: Number(formData.igstPercentage),
        totalPercentage:
          Number(formData.cgstPercentage || 0) +
          Number(formData.sgstPercentage || 0) +
          Number(formData.igstPercentage || 0),
      };

      const res = await onSubmit(payload);

      // BACKEND VALIDATION
      if (res?.status === 422 || res?.success === false) {
        if (typeof res?.error === "object") {
          setErrors(res.error);
        } else {
          setErrors({
            common: res?.error || res?.message,
          });
        }
        return;
      }

      setSuccessMessage(isEdit ? "Tax Updated Successfully" : "Tax Added Successfully");

      if (!isEdit) {
        setFormData(initialState);
      }

      setTimeout(() => {
        setSuccessMessage("");
        navigate("/tax");
      }, 1500);
    } catch (error) {
      const apiError = error?.response?.data?.error || error?.response?.data?.message;

      if (typeof apiError === "object") {
        setErrors(apiError);
      } else {
        setErrors({
          common: apiError || "Something went wrong",
        });
      }
    }
  };
  return (
    <div className="container">
      <div className="card shadow border-0 p-4">
        <h3>{isEdit ? "Edit Tax" : "Add Tax"}</h3>

        {successMessage && <div className="alert alert-success">{successMessage}</div>}

        <form onSubmit={handleSubmit}>
          <div className="row h80">
            <div className="col-md-12">
              <label>
                Tax Name <span className="error">*</span>{" "}
              </label>
              <input
                type="text"
                name="taxName"
                className="form-control"
                value={formData.taxName}
                onChange={handleChange}
              />
              {errors.taxName && (
                <div style={{ color: "red", fontSize: "14px" }}>{errors.taxName}</div>
              )}
            </div>
          </div>

          <div className="row h80">
            <div className="col-md-12">
              <label>
                CGST Percentage (%)<span className="error">*</span>{" "}
              </label>
              <input
                type="number"
                min="0"
                max="100"
                name="cgstPercentage"
                className="form-control"
                value={formData.cgstPercentage}
                onChange={handleChange}
              />
              {errors.cgstPercentage && (
                <div style={{ color: "red", fontSize: "14px" }}>{errors.cgstPercentage}</div>
              )}
            </div>
          </div>

          <div className="row h80">
            <div className="col-md-12">
              <label>
                SGST Percentage (%) <span className="error">*</span>
              </label>
              <input
                type="number"
                min="0"
                max="100"
                name="sgstPercentage"
                className="form-control"
                value={formData.sgstPercentage}
                onChange={handleChange}
              />
              {errors.sgstPercentage && (
                <div style={{ color: "red", fontSize: "14px" }}>{errors.sgstPercentage}</div>
              )}
            </div>
          </div>

          <div className="row h80">
            <div className="col-md-12">
              <label>
                IGST Percentage (%) <span className="error">*</span>
              </label>
              <input
                type="number"
                min="0"
                max="100"
                name="igstPercentage"
                className="form-control"
                value={formData.igstPercentage}
                onChange={handleChange}
              />
              {errors.igstPercentage && (
                <div style={{ color: "red", fontSize: "14px" }}>{errors.igstPercentage}</div>
              )}
            </div>
          </div>
          {!isEdit && (
            <div className="row h80">
              <div className="col-md-12">
                <label>
                  Total GST Percentage (%)<span className="error">*</span>
                </label>
                <input
                  type="number"
                  className="form-control"
                  value={
                    Number(formData.cgstPercentage || 0) +
                    Number(formData.sgstPercentage || 0) +
                    Number(formData.igstPercentage || 0)
                  }
                  readOnly
                />
              </div>
            </div>
          )}

          <div className="d-flex justify-content-end gap-2 mt-3">
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? "Submitting..." : isEdit ? "Update" : "Add Tax"}
            </button>

            <button
              type="button"
              className="btn"
              style={{ backgroundColor: "#032B4D", color: "#fff" }}
              onClick={() => navigate("/tax")}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
